(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939,2576,5124,949,2597,1620,5901,442,2274,7357],{

/***/ 93228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 82941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(93228),
    isIterateeCall = __webpack_require__(82406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(82941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 81745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Pricing/components/Hero/Hero.tsx






var copy = {
  heading: "Plans scale with your growth"
};
var Hero_button = {
  text: "Which plan is right for you?",
  url: "#which-plan-is-right-for-you"
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
            href: Hero_button.url,
            children: Hero_button.text
          })
        })]
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e19fv83y1"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e19fv83y0"
} : 0)(recipes_Hero/* Wrapper */.im, "{padding-bottom:0px;gap:0;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Paper/index.ts + 2 modules
var Paper = __webpack_require__(16164);
// EXTERNAL MODULE: ../../libs/matcha/components/Tooltip/index.ts + 2 modules
var Tooltip = __webpack_require__(57210);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/Pricing/components/PlansCards/PlansCards.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var getCards = function getCards(config, theme) {
  return [{
    title: "Free",
    excerpt: "Start sending customer data to your favorite marketing and analytics tools.",
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSignupButton, {
      size: "medium",
      variant: "outlined",
      children: "Create a free account"
    }),
    price: "$0/month",
    benefitsHeading: "What you can do:",
    benefits: ["Includes 1,000 visitors/mo", "500,000/mo Reverse ETL Records", "2 sources", "".concat("450", "+ Integrations"), "1 data warehouse destination"]
  }, {
    title: "Team",
    excerpt: "Unify your customer data and collect every touch point with full access to Connections.",
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSignupButton, {
      variant: "filled",
      size: "medium",
      additionalParams: {
        plan: "team-monthly"
      },
      children: "Try for free"
    }),
    price: "Starts at $120/month",
    benefitsHeading: "All of Free plus:",
    benefits: [["Includes 10,000 visitors/mo", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
      label: "+$10/mo for 1,000 monthly visitors",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
        color: theme.palette.twilio.gray[40]
      })
    }, "info-icon")], "1,000,000 Reverse ETL Records", "Unlimited Sources", "Public API Access"]
  }, {
    title: "Business",
    excerpt: "Solve complex business problems with standardized data and deploy the industry\u2019s #1 CDP for market share per IDC, 2022.",
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
      size: "medium",
      color: "primary",
      variant: "outlined",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", config),
      children: "Get a demo"
    }),
    price: "Custom Pricing",
    benefitsHeading: "All of Team plus:",
    benefits: ["Custom Volume", "Single View of the Customer", "Data Governance", "Advanced Roles & Permissions", "Personalized Customer Experiences", "HIPAA-eligibility (BAA Required)", ["Regional Segment (EU or US)", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
      label: "Segment offers regional infrastructure in both Europe and the United States",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
        color: theme.palette.twilio.gray[40]
      })
    }, "info-icon")]]
  }];
};

var PlansCards = function PlansCards() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlansCards_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            lg: 3
          },
          children: getCards(pageConfig, theme).map(function (card, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPaper, {
              elevation: 3,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                tag: "h2",
                variant: "h2",
                children: card.title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pMedium",
                children: card.excerpt
              }), card.button, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Price, {
                variant: "pLarge",
                children: card.price
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListHeading, {
                variant: "pMedium",
                children: card.benefitsHeading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                children: card.benefits.map(function (benefit, index) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledListItem, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Benefit, {
                      variant: "pMedium",
                      children: Array.isArray(benefit) ? benefit.map(function (item) {
                        return item;
                      }) : benefit
                    })
                  }, "benefit-".concat(index));
                })
              })]
            }, index);
          })
        })
      })
    })
  });
};

var PlansCards_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1v7z9q29"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1v7z9q28"
} : 0)("max-width:1320px;", Section/* Wrapper */.im, "{padding-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{row-gap:40px;}}" + ( true ? "" : 0));

var StyledPaper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Paper/* default */.Z,  true ? {
  target: "e1v7z9q27"
} : 0)("display:grid;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.neutrals.white[100];
}, ";padding:0px 24px 24px;grid-template-rows:10% 25% repeat(4, min-content) 1fr;max-width:327px;justify-self:center;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding:8px 32px 32px;grid-template-rows:10% 22.5% repeat(4, min-content) 1fr;max-width:352px;}" + ( true ? "" : 0));

var StyledSignupButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(SignupButton/* default */.Z,  true ? {
  target: "e1v7z9q26"
} : 0)( true ? {
  name: "16a84qv",
  styles: "width:100%;height:56px"
} : 0);

var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e1v7z9q25"
} : 0)( true ? {
  name: "16a84qv",
  styles: "width:100%;height:56px"
} : 0);

var Price = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1v7z9q24"
} : 0)( true ? {
  name: "1fs678t",
  styles: "overflow:hidden;white-space:nowrap;font-weight:600"
} : 0);

var ListHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1v7z9q23"
} : 0)( true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : 0);

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1v7z9q22"
} : 0)("margin-bottom:24px;padding-left:24px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("lg");
}, "{margin-bottom:0;}" + ( true ? "" : 0));

var StyledListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1v7z9q21"
} : 0)( true ? {
  name: "1s3jk2e",
  styles: "list-style-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.045.667a.91.91 0 0 1 .025 1.305L5.031 8.126a.95.95 0 0 1-1.356 0L.93 5.33a.91.91 0 0 1 .025-1.305.954.954 0 0 1 1.331.025l2.067 2.106L9.714.692a.954.954 0 0 1 1.33-.025Z' fill='%23121C2D'/%3e%3c/svg%3e \");font-weight:400;padding:0 0 8px 8px"
} : 0);

var Benefit = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1v7z9q20"
} : 0)( true ? {
  name: "wgm2x7",
  styles: "margin:0;display:flex;gap:8px"
} : 0);

/* harmony default export */ var PlansCards_PlansCards = (PlansCards);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
;// CONCATENATED MODULE: ./src/views/Pricing/components/LogoCarousel/LogoCarousel.tsx


function LogoCarousel_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var LogoCarousel_LogoCarousel = function LogoCarousel() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLogoCarousel, {})
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e124u1mx1"
} : 0)(Section/* Wrapper */.im, "{gap:0;padding-bottom:0;}" + ( true ? "" : 0));

var StyledLogoCarousel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LogoCarousel["default"],  true ? {
  target: "e124u1mx0"
} : 0)( true ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : 0);

/* harmony default export */ var components_LogoCarousel_LogoCarousel = (LogoCarousel_LogoCarousel);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TabsLayout/index.ts + 1 modules
var TabsLayout = __webpack_require__(82274);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Tabs/useTabs/index.ts + 1 modules
var useTabs = __webpack_require__(53834);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/FreePlan-xs.png
var FreePlan_xs = __webpack_require__(36819);
var FreePlan_xs_default = /*#__PURE__*/__webpack_require__.n(FreePlan_xs);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/FreePlan-xs.webp
var assets_FreePlan_xs = __webpack_require__(4659);
var assets_FreePlan_xs_default = /*#__PURE__*/__webpack_require__.n(assets_FreePlan_xs);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/FreePlan-sm.png
var FreePlan_sm = __webpack_require__(62454);
var FreePlan_sm_default = /*#__PURE__*/__webpack_require__.n(FreePlan_sm);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/FreePlan-sm@2x.png
var FreePlan_sm_2x = __webpack_require__(12034);
var FreePlan_sm_2x_default = /*#__PURE__*/__webpack_require__.n(FreePlan_sm_2x);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/FreePlan-sm.webp
var assets_FreePlan_sm = __webpack_require__(84337);
var assets_FreePlan_sm_default = /*#__PURE__*/__webpack_require__.n(assets_FreePlan_sm);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/FreePlan-sm@2x.webp
var assets_FreePlan_sm_2x = __webpack_require__(28805);
var assets_FreePlan_sm_2x_default = /*#__PURE__*/__webpack_require__.n(assets_FreePlan_sm_2x);
;// CONCATENATED MODULE: ./src/views/Pricing/components/WhichPlan/FreePlanImage.tsx











var FreePlanImage = function FreePlanImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("sm", false),
      type: "image/webp",
      srcSet: "".concat((assets_FreePlan_sm_default()), ", ").concat((assets_FreePlan_sm_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("sm", false),
      srcSet: "".concat((FreePlan_sm_default()), ", ").concat((FreePlan_sm_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      src: (assets_FreePlan_xs_default())
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "702",
      height: "538",
      src: (FreePlan_xs_default()),
      alt: "Illustration: Free Plan",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var WhichPlan_FreePlanImage = (FreePlanImage);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/TeamPlan-xs.png
var TeamPlan_xs = __webpack_require__(38620);
var TeamPlan_xs_default = /*#__PURE__*/__webpack_require__.n(TeamPlan_xs);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/TeamPlan-xs.webp
var assets_TeamPlan_xs = __webpack_require__(75764);
var assets_TeamPlan_xs_default = /*#__PURE__*/__webpack_require__.n(assets_TeamPlan_xs);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/TeamPlan-sm.png
var TeamPlan_sm = __webpack_require__(17400);
var TeamPlan_sm_default = /*#__PURE__*/__webpack_require__.n(TeamPlan_sm);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/TeamPlan-sm@2x.png
var TeamPlan_sm_2x = __webpack_require__(32551);
var TeamPlan_sm_2x_default = /*#__PURE__*/__webpack_require__.n(TeamPlan_sm_2x);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/TeamPlan-sm.webp
var assets_TeamPlan_sm = __webpack_require__(27236);
var assets_TeamPlan_sm_default = /*#__PURE__*/__webpack_require__.n(assets_TeamPlan_sm);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/TeamPlan-sm@2x.webp
var assets_TeamPlan_sm_2x = __webpack_require__(92147);
var assets_TeamPlan_sm_2x_default = /*#__PURE__*/__webpack_require__.n(assets_TeamPlan_sm_2x);
;// CONCATENATED MODULE: ./src/views/Pricing/components/WhichPlan/TeamPlanImage.tsx











var TeamPlanImage = function TeamPlanImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("sm", false),
      type: "image/webp",
      srcSet: "".concat((assets_TeamPlan_sm_default()), ", ").concat((assets_TeamPlan_sm_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("sm", false),
      srcSet: "".concat((TeamPlan_sm_default()), ", ").concat((TeamPlan_sm_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      src: (assets_TeamPlan_xs_default())
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "702",
      height: "538",
      src: (TeamPlan_xs_default()),
      alt: "Illustration: Team Plan",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var WhichPlan_TeamPlanImage = (TeamPlanImage);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/BusinessPlan-xs.png
var BusinessPlan_xs = __webpack_require__(55084);
var BusinessPlan_xs_default = /*#__PURE__*/__webpack_require__.n(BusinessPlan_xs);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/BusinessPlan-xs.webp
var assets_BusinessPlan_xs = __webpack_require__(53448);
var assets_BusinessPlan_xs_default = /*#__PURE__*/__webpack_require__.n(assets_BusinessPlan_xs);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/BusinessPlan-sm.png
var BusinessPlan_sm = __webpack_require__(70142);
var BusinessPlan_sm_default = /*#__PURE__*/__webpack_require__.n(BusinessPlan_sm);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/BusinessPlan-sm@2x.png
var BusinessPlan_sm_2x = __webpack_require__(501);
var BusinessPlan_sm_2x_default = /*#__PURE__*/__webpack_require__.n(BusinessPlan_sm_2x);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/BusinessPlan-sm.webp
var assets_BusinessPlan_sm = __webpack_require__(17839);
var assets_BusinessPlan_sm_default = /*#__PURE__*/__webpack_require__.n(assets_BusinessPlan_sm);
// EXTERNAL MODULE: ./src/views/Pricing/components/WhichPlan/assets/BusinessPlan-sm@2x.webp
var assets_BusinessPlan_sm_2x = __webpack_require__(44270);
var assets_BusinessPlan_sm_2x_default = /*#__PURE__*/__webpack_require__.n(assets_BusinessPlan_sm_2x);
;// CONCATENATED MODULE: ./src/views/Pricing/components/WhichPlan/BusinessPlanImage.tsx











var BusinessPlanImage = function BusinessPlanImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      media: theme.breakpoints.up("sm", false),
      srcSet: "".concat((assets_BusinessPlan_sm_default()), ", ").concat((assets_BusinessPlan_sm_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("sm", false),
      srcSet: "".concat((BusinessPlan_sm_default()), ", ").concat((BusinessPlan_sm_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      src: (assets_BusinessPlan_xs_default())
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "702",
      height: "658",
      src: (BusinessPlan_xs_default()),
      alt: "Illustration: Business Plan",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var WhichPlan_BusinessPlanImage = (BusinessPlanImage);
;// CONCATENATED MODULE: ./src/views/Pricing/components/WhichPlan/data.tsx








var data = function data(config) {
  return [{
    key: "free",
    title: "Free",
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhichPlan_FreePlanImage, {}),
    contentHeading: "Free plan",
    list: [{
      name: "Collect data from 2 sources",
      check: true
    }, {
      name: "Send data to unlimited destinations",
      check: true
    }, {
      name: "Up to 1,000 monthly users",
      check: true
    }, {
      name: "Enforce data quality (Add-on)",
      check: false
    }, {
      name: "Build a complete view of your customer",
      check: false
    }, {
      name: "Orchestrate personalized Journeys (Add-on)",
      check: false
    }, {
      name: "Deliver omnichannel experiences (Add-on)",
      check: false
    }, {
      name: "Transform and enrich your data",
      check: false
    }, {
      name: "Set granular user roles and permissions",
      check: false
    }],
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
      variant: "outlined",
      children: "Create a free account"
    })
  }, {
    key: "team",
    title: "Team",
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhichPlan_TeamPlanImage, {}),
    list: [{
      name: "Collect data from unlimited sources",
      check: true
    }, {
      name: "Send data to unlimited destinations",
      check: true
    }, {
      name: "10,000 monthly users included",
      check: true
    }, {
      name: "Enforce data quality (Add-on)",
      check: false
    }, {
      name: "Build a complete view of your customer",
      check: false
    }, {
      name: "Orchestrate personalized Journeys (Add-on)",
      check: false
    }, {
      name: "Deliver omnichannel experiences (Add-on)",
      check: false
    }, {
      name: "Transform and enrich your data",
      check: false
    }, {
      name: "Set granular user roles and permissions",
      check: false
    }],
    hint: "14-day free trial",
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
      children: "Try for free"
    })
  }, {
    key: "business",
    title: "Business",
    image: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhichPlan_BusinessPlanImage, {}),
    list: [{
      name: "Collect data from unlimited sources",
      check: true
    }, {
      name: "Send data to unlimited destinations",
      check: true
    }, {
      name: "Custom volume",
      check: true
    }, {
      name: "Enforce data quality (Add-on)",
      check: true
    }, {
      name: "Build a complete view of your customer",
      check: true
    }, {
      name: "Orchestrate personalized Journeys (Add-on)",
      check: true
    }, {
      name: "Deliver omnichannel experiences (Add-on)",
      check: true
    }, {
      name: "Transform and enrich your data",
      check: true
    }, {
      name: "Set granular user roles and permissions",
      check: true
    }, {
      name: "Enable HIPAA-eligible Workspaces (Add-on)",
      check: true
    }],
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      variant: "outlined",
      size: "large",
      color: "primary",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", config),
      children: "Get a demo"
    })
  }];
};

/* harmony default export */ var WhichPlan_data = (data);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./src/views/Pricing/components/WhichPlan/WhichPlan.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function WhichPlan_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var WhichPlan_copy = {
  heading: "Which plan is right for you?"
};

var WhichPlan = function WhichPlan() {
  var config = (0,page/* usePageConfig */.Gm)();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useTabs = (0,useTabs/* default */.Z)(0, WhichPlan_data(config).length, "which-plan"),
      getTrackProps = _useTabs.getTrackProps,
      getControlProps = _useTabs.getControlProps,
      getPanelProps = _useTabs.getPanelProps,
      activeTabKey = _useTabs.activeTabKey;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionComponent, {
    variant: "centered",
    id: "which-plan-is-right-for-you",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: WhichPlan_copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabsLayout/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Controls */.ZX, _objectSpread(_objectSpread({}, getTrackProps()), {}, {
          children: WhichPlan_data(config).map(function (tab, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Control */.oT, _objectSpread(_objectSpread({}, getControlProps(index)), {}, {
              children: tab.title
            }), tab.key);
          })
        })), WhichPlan_data(config).map(function (tab, index) {
          return (0,emotion_react_browser_esm/* createElement */.az)(TabsLayout/* Content */.VY, _objectSpread(_objectSpread({}, getPanelProps(index)), {}, {
            active: index === activeTabKey,
            key: tab.key
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabsLayout/* Copy */.CK, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlanHeading, {
              variant: "h4",
              tag: "h3",
              children: [tab.title, " plan:"]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhichPlan_List, {
              children: tab.list.map(function (item) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListItem, {
                  checked: item.check,
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* CheckIcon */.nQ, {
                    size: "small",
                    color: theme.palette.twilio.gray[item.check ? 100 : 30]
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
                    variant: "pMedium",
                    tokens: {
                      color: theme.palette.twilio.gray[item.check ? 100 : 30]
                    },
                    children: item.name
                  })]
                }, item.name);
              })
            }), tab.hint && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
              variant: "pMedium",
              children: tab.hint
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
              children: /*#__PURE__*/(0,react.cloneElement)(tab.button, {
                expanded: true
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabsLayout/* Media */.pU, {
            children: tab.image
          }));
        })]
      })
    })]
  });
};

var SectionComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1yz3t55"
} : 0)("overflow:hidden;", Section/* Wrapper */.im, "{padding-top:120px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:80px;}}" + ( true ? "" : 0));

var PlanHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1yz3t54"
} : 0)( true ? {
  name: "1i9vogi",
  styles: "margin-top:0"
} : 0);

var WhichPlan_List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1yz3t53"
} : 0)( true ? {
  name: "ncn5z3",
  styles: "list-style:none;display:grid;gap:12px;padding:0"
} : 0);

var ListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1yz3t52"
} : 0)( true ? {
  name: "1yydxi7",
  styles: "display:flex;align-items:center;gap:8px"
} : 0);

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1yz3t51"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yz3t50"
} : 0)("margin-top:40px;width:100%;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{width:fit-content;}" + ( true ? "" : 0));

/* harmony default export */ var WhichPlan_WhichPlan = (WhichPlan);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TablePricing/index.tsx + 31 modules
var TablePricing = __webpack_require__(16410);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TablePricing/Icons/index.ts + 1 modules
var Icons = __webpack_require__(88610);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/views/Pricing/components/ComparePlans/data.tsx







var sections = function sections(params) {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return [{
    header: "Collect and send data anywhere",
    rows: [{
      header: "Sources",
      tooltip: "Use a single API to capture and send customer data exactly where you need it",
      cells: ["2 Sources", "Unlimited", "Unlimited"],
      subRows: [{
        header: "Web",
        tooltip: "Collect customer data from your website with the Segment javascript library",
        cells: [true, true, true]
      }, {
        header: "Mobile",
        tooltip: "Collect customer data from your mobile apps with SDKs for iOS, Android, and more",
        cells: [true, true, true]
      }, {
        header: "Server",
        tooltip: "Send customer data directly from your servers",
        cells: [true, true, true]
      }, {
        header: "Cloud Apps",
        tooltip: "Connect platforms like Salesforce, Stripe, Facebook Ads, and more",
        cells: [true, true, true]
      }]
    }, {
      header: "Destinations",
      tooltip: "Send your data to ".concat("450", "+ tools for product analytics, advertising, email, and more"),
      cells: ["Unlimited", "Unlimited", "Unlimited"]
    }, {
      header: "Functions",
      tooltip: "Create your own sources and destinations directly within your workspace. This is an optional feature subject to additional terms.",
      cells: ["50 Hours", "50 Hours", "Custom"]
    }, {
      header: "Warehouses",
      tooltip: "Transform and load your data into Redshift, BigQuery, Postgres, Snowflake, or IBM DB2",
      cells: ["1 Warehouse", "1 Warehouse", "Unlimited"],
      subRows: [{
        header: "Sync frequency",
        tooltip: "Choose how often and when you load data into your warehouse",
        cells: ["1 per day", "2 per day", "Custom Schedule"]
      }, {
        header: "Selective sync",
        tooltip: "Choose which events and properties sync to your warehouse",
        cells: [false, false, true]
      }]
    }, {
      header: "Reverse ETL",
      tooltip: "Activate data from the warehouse into ".concat("450", "+ tools for product analytics, advertising, email, and more"),
      cells: [true, true, true]
    }, {
      header: "Developer Tools",
      tooltip: "Set up, test, and swap new tools with a common UI and data observability",
      cells: [true, true, true],
      subRows: [{
        header: "Central view of data schema",
        tooltip: "See a list of all events, traits, and more you've sent to Segment",
        cells: [true, true, true]
      }, {
        header: "Live data view and debugger",
        tooltip: "View live data passing through Segment to test your tracking code",
        cells: [true, true, true]
      }]
    }, {
      header: "Public API",
      tooltip: "Programmatically manage Segment workspaces, sources, destinations, and more",
      cells: [false, true, true]
    }]
  }, {
    header: "Control your data quality",
    rows: [{
      header: "Data privacy and controls",
      tooltip: "Take a proactive approach to privacy and easily control where your data flows ",
      cells: [true, true, true],
      subRows: [{
        header: "User deletion",
        tooltip: "Manage user deletion across Segment and supported destinations",
        cells: [true, true, true]
      }, {
        header: "User suppression",
        tooltip: "Block data collection for specific users with one-click suppression",
        cells: [true, true, true]
      }, {
        header: "Customer data discovery and inventory",
        tooltip: "Automatically detect and classify personal information in real time",
        cells: [true, true, true]
      }, {
        header: "Destination filters",
        tooltip: "Activate the data flowing into each destination",
        cells: [false, false, true]
      }, {
        header: "Replay historical data",
        tooltip: "Load all of your historical data into new tools",
        cells: [false, false, true]
      }]
    }, {
      header: "Advanced data governance: Protocols",
      tooltip: "Automatically enforce data quality",
      cells: [false, false, "+ Add-on"],
      subRows: [{
        header: "Integrated tracking plan",
        tooltip: "Create and manage a data tracking plan in your workspace",
        cells: [false, false, "+ Add-on"]
      }, {
        header: "Data validation",
        tooltip: "QA your implementation with automated data validation and violation reporting",
        cells: [false, false, "+ Add-on"]
      }, {
        header: "Enforcement",
        tooltip: "Automatically prevent unplanned or invalid data from being sent to Segment",
        cells: [false, false, "+ Add-on"]
      }, {
        header: "Transformations",
        tooltip: "Transform events without code",
        cells: [false, false, "+ Add-on"]
      }]
    }]
  }, {
    header: "Complete view of your customer",
    rows: [{
      header: "Unified customer data",
      tooltip: "Send data to a data warehouse to tie disparate events and interactions into unified profiles",
      cells: [true, true, true]
    }, {
      header: "Identity Resolution",
      tooltip: "Unify user history across devices and channels into one comprehensive profile",
      cells: [false, false, "+ Add-on"]
    }, {
      header: "Profile API Access",
      tooltip: "Programmatic access to Personas for in-app and onsite personalization",
      cells: [false, false, "+ Add-on"]
    }, {
      header: "Profiles Sync",
      tooltip: "Sync identity resolved customer profiles to the warehouse",
      cells: [false, false, "+ Add-on"]
    }]
  }, {
    header: "Build personalized customer experiences",
    rows: [{
      header: "Trait and audience building",
      tooltip: "Create real-time audiences and profiles",
      cells: [false, false, "+ Add-on"]
    }, {
      header: "Journeys",
      tooltip: "Orchestrate and experiment with personalized journeys across multiple channels based on real-time customer behavior",
      cells: [false, false, "+ Add-on"]
    }, {
      header: "Channels (native SMS/email currently not supported in EMEA)",
      tooltip: "Deliver personalized experiences where, when, and how your customers want with our native email and SMS channels, custom channels and ".concat("450", "+ out-of-the-box integrations"),
      cells: [false, false, "+ Add-on"]
    }]
  }, {
    header: "Usage and billing",
    rows: [{
      header: "Monthly Tracked Users",
      tooltip: "The number of anonymous and logged-in visitors that you track with Segment",
      cells: ["Up to 1,000", "Base includes 10,000", "Custom volume"],
      subRows: [{
        header: "Throughput Limit",
        tooltip: "Your customer data comes in the form of API Calls and Objects. Free and Team plans include up to 250 API Calls and Objects per MTU. The vast majority of Segment customers use well under these limits. Business plans are eligible for custom limits.",
        cells: ["Standard", "Standard", "Custom"]
      }]
    }, {
      header: "Price",
      cells: ["Free", "Starting at $120/month", "Custom"],
      subRows: [{
        header: "Additional 1,000 monthly tracked users (10K - 25K)",
        cells: [false, "+ $12", false]
      }, {
        header: "Additional 1,000 monthly tracked users (25K - 100K)",
        cells: [false, "+ $11", false]
      }, {
        header: "Additional 1,000 monthly tracked users (100K+)",
        cells: [false, "+ $10", false]
      }]
    }, {
      header: "Seats",
      tooltip: "The number of teammates that can access your Segment workspace",
      cells: ["10", "10", "Unlimited"]
    }, {
      header: "Payment Method",
      cells: [false, "Credit Card", "Invoice"]
    }, {
      header: "Contract Length",
      cells: [false, (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
        children: ["Annual or Monthly", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "(", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "pMedium",
          tag: "span",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: (0,getAbsoluteUrl/* default */.Z)("/signup/?plan=team-yearly".concat(params ? "&".concat(params) : ""), pageConfig),
            children: "save up to 20% annually"
          })
        }), ")"]
      }, "annual-or-monthly"), "Unlimited"]
    }]
  }, {
    header: "Support",
    rows: [{
      header: "Email/Web support",
      cells: [true, true, true]
    }, {
      header: "On-demand videos and documentation",
      tooltip: "Get up-and-running quickly with developer documentation and on-demand training",
      cells: [true, true, true]
    }, {
      header: "Dedicated Support",
      cells: [false, false, "Available"],
      subRows: [{
        header: "Customer Success Manager",
        tooltip: "Customer Success Manager may be included based on your annual agreement. Please ask your Account Executive for details.",
        cells: [false, false, "Available"]
      }, {
        header: "Advisory Services or Professional Services",
        tooltip: "Custom advisory services and professional services packages available. Please ask your Account Executive for details.",
        cells: [false, false, "+ Add-on"]
      }]
    }, {
      header: "Uptime SLA",
      tooltip: "Guaranteed API uptime",
      cells: [true, true, true]
    }]
  }, {
    header: "Security",
    rows: [{
      header: "Account Security",
      tooltip: "Protect your workspace with personalized security settings",
      cells: [true, true, true],
      subRows: [{
        header: "Multi-factor authentication",
        tooltip: "Provide an additional layer of security beyond your username and password. When logging into Segment, users will also enter a code from their mobile phone.",
        cells: [true, true, true]
      }, {
        header: "Single Sign-on",
        tooltip: "Centrally manage your policies for access with Single Sign-On (SSO)",
        cells: [false, false, true]
      }, {
        header: "Granular roles and user permissions",
        tooltip: "Control access to your sources and workspaces with fine-grained permissions to manage how your teammates interact with your data",
        cells: [false, false, true]
      }]
    }, {
      header: "Certifications",
      tooltip: "To learn more about Segment's security and privacy program, and certifications and attestations, visit here",
      cells: [true, true, true]
    }, {
      header: "HIPAA-eligibility",
      tooltip: "Store and manage PHI within your workspace",
      cells: [false, false, "+ Add-on"]
    }, {
      header: "Regional Segment (EU or US)",
      tooltip: "Segment offers regional infrastructure in both Europe and the United States",
      cells: [false, false, true]
    }]
  }];
};

/* harmony default export */ var ComparePlans_data = (sections);
;// CONCATENATED MODULE: ./src/views/Pricing/components/ComparePlans/ComparePlans.tsx


function ComparePlans_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var ComparePlans_copy = {
  heading: "Compare plans"
};
var ComparePlans_link = {
  text: "Get a demo",
  url: "/demo/"
};

var ComparePlans = function ComparePlans() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(theme.breakpoints.up("xxl", false), true);
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var params = pageConfig.queryParamsFromCookie;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ComparePlans_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          children: ComparePlans_copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* default */.ZP, {
        columns: 3,
        scrollable: !isDesktopResolution,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* Header */.h4, {
          sticky: true,
          pinFirst: true,
          tokens: {
            top: isDesktopResolution ? 76 : 0
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Free",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
              variant: "outlined",
              size: "medium",
              children: "Create a free account"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Team",
            hint: "14 day free trial",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
              additionalParams: {
                plan: "team-monthly"
              },
              size: "medium",
              children: "Try for free"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Business",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              href: (0,getAbsoluteUrl/* default */.Z)(ComparePlans_link.url, pageConfig),
              variant: "outlined",
              color: "primary",
              size: "medium",
              children: ComparePlans_link.text
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Body */.uT, {
          children: ComparePlans_data(params).map(function (section, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* SectionHeader */.M$, {
                children: section.header
              }), section.rows.map(function (row) {
                var _row$subRows;

                return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Row */.X2, {
                    header: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* RowHeader */.yD, {
                      icon: row.tooltip && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                        label: row.tooltip,
                        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
                          color: theme.palette.twilio.gray[40]
                        })
                      }),
                      children: row.header
                    }),
                    children: row.cells.map(function (cell, index) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureCell, {
                        feature: cell
                      }, index);
                    })
                  }), row === null || row === void 0 ? void 0 : (_row$subRows = row.subRows) === null || _row$subRows === void 0 ? void 0 : _row$subRows.map(function (subRow) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Row */.X2, {
                      header: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* RowSubHeader */.Do, {
                        icon: subRow.tooltip && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                          label: subRow.tooltip,
                          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
                            color: theme.palette.twilio.gray[40]
                          })
                        }),
                        children: subRow.header
                      }),
                      children: subRow.cells.map(function (subRowCell, index) {
                        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureCell, {
                          feature: subRowCell
                        }, index);
                      })
                    }, subRow.header);
                  })]
                }, row.header);
              }), index !== ComparePlans_data.length - 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* EmptyRow */.O7, {})]
            }, section.header);
          })
        })]
      })
    })]
  });
};

var ComparePlans_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e17rq3lm0"
} : 0)( true ? {
  name: "hc6m9z",
  styles: "overflow:initial"
} : 0);

var FeatureCell = function FeatureCell(_ref) {
  var feature = _ref.feature;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Cell */.bL, {
    children: typeof feature === "boolean" ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureIcon, {
      featureEnabled: feature
    }) : feature
  });
};

var FeatureIcon = function FeatureIcon(_ref2) {
  var featureEnabled = _ref2.featureEnabled;
  return featureEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons/* CheckIcon */.n, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u2014"
  });
};

/* harmony default export */ var ComparePlans_ComparePlans = (ComparePlans);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ./src/views/Pricing/components/Faq/data.ts

var faqs = [{
  title: "How can I estimate my MTUs?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "To get an idea of your MTU count, add your monthly active users to the number of anonymous visitors you get per month. Some tools also call this metric \"Monthly Unique Visitors.\"",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Is there a free trial of the paid plans?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        content: [{
          data: {},
          marks: [],
          value: "Yes! There is a 14-day free trial for the Team plan. To try the Business plan, please ",
          nodeType: "text"
        }, {
          data: {
            uri: "/demo/"
          },
          content: [{
            data: {},
            marks: [],
            value: "contact us",
            nodeType: "text"
          }],
          nodeType: dist.INLINES.HYPERLINK
        }, {
          data: {},
          marks: [],
          value: ".",
          nodeType: "text"
        }],
        nodeType: dist.BLOCKS.PARAGRAPH
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Does Segment handle billing for my Sources or Destinations services?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "No, you\u2019re responsible for accounts that you register with Sources, Integrations, and Warehouse providers, whether they are paid or free.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "What is the benefit of an annual plan?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "If you are on the monthly billing plan, your bill may fluctuate each month based on your user activity. The annual plan allows you to purchase MTU at a lower rate. Exceeding the allotted MTU count on annual plans may incur additional charges.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Do I need to have a data warehouse to use Warehouses?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "Yes! Segment connects to your existing data warehouse and pipes in data collected from your Sources. You don't have to worry about the ETL or maintaining the data pipeline.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "How can I buy Protocols, Unify or Twilio Engage?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "Protocols, Unify and Twilio Engage are offered as an add-on to your Segment plan. ",
        nodeType: "text"
      }, {
        data: {
          uri: "/demo/"
        },
        content: [{
          data: {},
          marks: [],
          value: "Contact us",
          nodeType: "text"
        }],
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: " to learn more about what plan is best for you.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}];
;// CONCATENATED MODULE: ./src/views/Pricing/components/Faq/FAQ.tsx


function FAQ_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var FAQ_data = {
  heading: "Frequently asked questions",
  faqs: faqs
};

var FAQ = function FAQ() {
  var items = new Array(FAQ_data.faqs.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FAQ_StyledSectionBase, {
    variant: "centered",
    id: "faq",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          dangerouslySetInnerHTML: {
            __html: sanitize_html_default()(FAQ_data.heading)
          }
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: activeItems.map(function (active, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return toggle(index);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                opened: active,
                tag: "h3",
                children: FAQ_data.faqs[index].title
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: active
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
                  data: FAQ_data.faqs[index].description
                })
              })
            })
          })]
        }, "item-".concat(index));
      })
    })]
  });
};

var FAQ_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1d1j5gd1"
} : 0)("overflow:inherit;", Section/* Wrapper */.im, "{justify-content:stretch;}" + ( true ? "" : 0));

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1d1j5gd0"
} : 0)( true ? {
  name: "1h9b9cv",
  styles: "max-width:844px;width:100%"
} : 0);

/* harmony default export */ var Faq_FAQ = (FAQ);
;// CONCATENATED MODULE: ./src/views/Pricing/Pricing.tsx
















var Pricing = function Pricing() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Twilio Segment Pricing Options | Twilio Segment",
      pageDescription: "Twilio Segment offers plans and pricing for any budget. Find a pricing plan which fits your needs best.",
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlansCards_PlansCards, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LogoCarousel_LogoCarousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhichPlan_WhichPlan, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComparePlans_ComparePlans, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FAQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "el7j1ec0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Pricing_Pricing = (Pricing);
;// CONCATENATED MODULE: ./src/pages/pricing/index.tsx



var pricing_Pricing = function Pricing() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pricing_Pricing, {});
};

/* harmony default export */ var pricing = (pricing_Pricing);

/***/ }),

/***/ 57210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Tooltip_Tooltip; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/react/dist/floating-ui.react.mjs + 1 modules
var floating_ui_react = __webpack_require__(63607);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
var floating_ui_dom = __webpack_require__(75580);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
var floating_ui_core = __webpack_require__(84061);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(92416);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/components/Tooltip/Tooltip.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1sahzvu2"
} : 0)( true ? {
  name: "1lv1yo7",
  styles: "display:inline-flex"
} : 0);
var Target = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1sahzvu1"
} : 0)("display:inline-flex;line-height:1;transition:opacity 0.2s ease-in-out;opacity:", function (_ref) {
  var opacity = _ref.opacity;
  return opacity;
}, ";" + ( true ? "" : 0));
var Tooltip = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.span,  true ? {
  target: "e1sahzvu0"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.formHint;
}, ";padding:4px 8px;border-radius:2px;color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";background-color:", function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor;
}, ";max-width:360px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("md");
}, "{max-width:280px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Tooltip/Tooltip.tsx


var _excluded = ["children", "label", "tokens", "placement", "offset", "withArrow", "delay", "idleTargetOpacity"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var BaseTooltip = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      label = _ref.label,
      tokens = _ref.tokens,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "right" : _ref$placement,
      _ref$offset = _ref.offset,
      offsetNumber = _ref$offset === void 0 ? 10 : _ref$offset,
      _ref$withArrow = _ref.withArrow,
      withArrow = _ref$withArrow === void 0 ? true : _ref$withArrow,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 200 : _ref$delay,
      idleTargetOpacity = _ref.idleTargetOpacity,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var arrowRef = (0,react.useRef)(null);

  var _useFloating = (0,floating_ui_react/* useFloating */.YF)({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: placement,
    whileElementsMounted: floating_ui_dom/* autoUpdate */.Me,
    middleware: [(0,floating_ui_core/* offset */.cv)(offsetNumber), (0,floating_ui_dom/* flip */.RR)({
      fallbackAxisSideDirection: "start"
    }), (0,floating_ui_dom/* shift */.uY)(), (0,floating_ui_react_dom/* arrow */.x7)({
      element: arrowRef
    })]
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles,
      context = _useFloating.context;

  var hover = (0,floating_ui_react/* useHover */.XI)(context, {
    move: false,
    delay: delay
  });
  var focus = (0,floating_ui_react/* useFocus */.KK)(context);
  var dismiss = (0,floating_ui_react/* useDismiss */.bQ)(context);
  var role = (0,floating_ui_react/* useRole */.qs)(context, {
    role: "tooltip"
  });

  var _useTransitionStyles = (0,floating_ui_react/* useTransitionStyles */.Y_)(context, {
    duration: delay
  }),
      isMounted = _useTransitionStyles.isMounted,
      styles = _useTransitionStyles.styles;

  var _useInteractions = (0,floating_ui_react/* useInteractions */.NI)([hover, focus, dismiss, role]),
      getReferenceProps = _useInteractions.getReferenceProps,
      getFloatingProps = _useInteractions.getFloatingProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Target, _objectSpread(_objectSpread({
      ref: refs.setReference,
      opacity: isOpen ? 1 : idleTargetOpacity !== null && idleTargetOpacity !== void 0 ? idleTargetOpacity : 1
    }, getReferenceProps()), {}, {
      children: children
    })), isMounted && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tooltip, _objectSpread(_objectSpread(_objectSpread({
      ref: refs.setFloating,
      style: _objectSpread(_objectSpread({}, floatingStyles), styles)
    }, tokens), getFloatingProps()), {}, {
      children: [label, withArrow && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(floating_ui_react/* FloatingArrow */.Y$, {
        ref: arrowRef,
        context: context,
        fill: tokens.backgroundColor,
        "data-testid": "tooltip-arrow"
      })]
    }))]
  }));
});
var Tooltip_Tooltip = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTooltip, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      color: theme.palette.twilio.gray[60],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  },
  light: function light(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      backgroundColor: theme.palette.twilio.gray[60]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      backgroundColor: theme.palette.twilio.gray[60]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Tooltip/index.ts


/***/ }),

/***/ 83914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "vs": function() { return /* reexport */ ContentWrapper_ContentWrapper; },
  "h4": function() { return /* reexport */ Accordion_Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "yD": function() { return /* reexport */ JsonLdFaq; },
  "DK": function() { return /* reexport */ Accordion_SubTitle_SubTitle; },
  "xv": function() { return /* reexport */ Accordion_Text_Text; },
  "Dx": function() { return /* reexport */ Accordion_Title_Title; },
  "$t": function() { return /* reexport */ TitleWrapper_TitleWrapper; },
  "ZP": function() { return /* reexport */ Accordion_Base_Base; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var VerticalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u2"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";opacity:", function (_ref2) {
  var opacity = _ref2.opacity;
  return opacity;
}, ";width:2px;height:12px;transition:300ms background,300ms opacity;position:absolute;top:0;left:5px;" + ( true ? "" : 0));
var HorizontalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u1"
} : 0)("background:", function (_ref3) {
  var background = _ref3.background;
  return background;
}, ";width:12px;height:2px;transition:300ms background;position:absolute;top:5px;left:0;" + ( true ? "" : 0));
var IconStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u0"
} : 0)( true ? {
  name: "xcbroa",
  styles: "width:12px;height:12px;position:relative"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalLine, _objectSpread({}, tokens)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine, _objectSpread({}, tokens))]
  }));
});
var Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.views.ts

var Base = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejcpq100"
} : 0)("width:100%;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.tsx


var Base_excluded = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var AccordionBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Base_Base = (0,useDesignTokens/* withDesignTokens */.Y)(AccordionBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Accordion_Base_Base = (Base_Base);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.views.ts


function Text_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1abg28t0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.tsx


var Text_excluded = ["children", "variant", "tokens"];

function Text_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Text_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, Text_objectSpread(Text_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Text_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    initial: false,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.views.ts


function ContentWrapper_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuwow0"
} : 0)( true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.tsx


var ContentWrapper_excluded = ["children"];

function ContentWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ContentWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ContentWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ContentWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, ContentWrapper_objectSpread(ContentWrapper_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
/* harmony default export */ var ContentWrapper_ContentWrapper = (ContentWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.views.ts


function Title_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enok57o0"
} : 0)( true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.tsx


var Title_excluded = ["children", "variant", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var opened = _ref2.opened;
    return {
      color: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      color: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      color: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Title_Title = (Title_Title);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.views.ts


function SubTitle_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var SubTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elm17wd0"
} : 0)( true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.tsx


var SubTitle_excluded = ["children", "variant", "tokens"];

function SubTitle_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SubTitle_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SubTitle_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubTitle_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSubTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SubTitle_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, SubTitle_objectSpread(SubTitle_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var SubTitle_SubTitle = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_SubTitle_SubTitle = (SubTitle_SubTitle);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/index.ts

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/JsonLdFaq.tsx


var JsonLdFaq = function JsonLdFaq(_ref) {
  var data = _ref.data;
  var entities = data.map(function (_ref2) {
    var question = _ref2.question,
        answer = _ref2.answer;
    return {
      '@type': "Question",
      name: question,
      acceptedAnswer: {
        '@type': "Answer",
        text: answer
      }
    };
  });
  var json = {
    '@context': "https://schema.org",
    '@type': "FAQPage",
    mainEntity: entities
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(json)
      }
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/TitleWrapper.tsx


var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ehyoi0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TitleWrapper_TitleWrapper = (TitleWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.views.ts



var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eqrws8a0"
} : 0)("width:100%;display:grid;gap:28px;grid-template-columns:auto auto;align-items:center;justify-content:space-between;cursor:pointer;margin:12px 0;:hover{", Title, "{color:", function (_ref) {
  var hoverTitleColor = _ref.hoverTitleColor;
  return hoverTitleColor;
}, ";}", HorizontalLine, ",", VerticalLine, "{background-color:", function (_ref2) {
  var hoverIconBackgroundColor = _ref2.hoverIconBackgroundColor;
  return hoverIconBackgroundColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.tsx


var Header_excluded = ["children", "onClick", "tokens"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var HeaderBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, Header_objectSpread(Header_objectSpread(Header_objectSpread({
    onClick: onClick
  }, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Header_Header = (0,useDesignTokens/* withDesignTokens */.Y)(HeaderBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      hoverTitleColor: theme.palette.brand.segmentGreen[500],
      hoverIconBackgroundColor: theme.palette.brand.segmentGreen[500]
    };
  },
  light: function light(theme) {
    return {
      hoverTitleColor: theme.palette.brand.boysenberry[500],
      hoverIconBackgroundColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverTitleColor: theme.palette.twilio.blue[60],
      hoverIconBackgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var Accordion_Header_Header = (Header_Header);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/index.ts










Accordion_Base_Base.displayName = "AccordionBase";
Accordion_Header_Header.displayName = "Accordion.Header";
Body_Body.displayName = "Accordion.Body";
Accordion_Text_Text.displayName = "Accordion.Text";
Accordion_Title_Title.displayName = "Accordion.Title";
Accordion_SubTitle_SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper_TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper_ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon_Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 82274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VY": function() { return /* reexport */ Content; },
  "oT": function() { return /* reexport */ Control; },
  "ZX": function() { return /* reexport */ Controls; },
  "CK": function() { return /* reexport */ Copy; },
  "pU": function() { return /* reexport */ Media; },
  "ZP": function() { return /* reexport */ TabsLayout_TabsLayout; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Tabs/index.ts + 12 modules
var Tabs = __webpack_require__(15347);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TabsLayout/TabsLayout.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tabs/* Panel */.s_,  true ? {
  target: "e14nbdi65"
} : 0)("grid-area:content;display:grid;gap:80px;grid-template-areas:'copy media';justify-content:center;justify-items:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("sm");
}, "{gap:40px;grid-template-areas:'copy' 'media';}" + ( true ? "" : 0));
var TabsLayout = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14nbdi64"
} : 0)("display:grid;grid-template-areas:'controls' 'content';gap:56px;justify-content:center;justify-items:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("sm");
}, "{gap:40px;}", function (_ref3) {
  var reverse = _ref3.reverse,
      theme = _ref3.theme;
  return reverse && "\n    ".concat(Content, " {\n      grid-template-areas:\n      'media copy';\n\n      ").concat(theme.breakpoints.down("sm"), " {\n        gap: 40px;\n        grid-template-areas:\n          'copy'\n          'media';\n      }\n    }\n  ");
}, ";" + ( true ? "" : 0));
var Controls = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tabs/* Track */.fQ,  true ? {
  target: "e14nbdi63"
} : 0)( true ? {
  name: "17k349u",
  styles: "grid-area:controls"
} : 0);
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14nbdi62"
} : 0)("grid-area:copy;display:grid;grid-template-columns:1fr;align-items:center;", function (_ref4) {
  var align = _ref4.align;
  return align === "start" && "\n    align-self: start;\n  ";
}, " ", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("md");
}, "{max-width:420px;}" + ( true ? "" : 0));
var Media = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e14nbdi61"
} : 0)("grid-area:media;display:grid;grid-template-columns:1fr;align-items:center;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("md");
}, "{max-width:600px;}" + ( true ? "" : 0));
var Control = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tabs/* Control */.oT,  true ? {
  target: "e14nbdi60"
} : 0)( true ? "" : 0);
/* harmony default export */ var TabsLayout_TabsLayout = (TabsLayout);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/TabsLayout/index.ts

TabsLayout.displayName = "TabsLayoutBase";
Copy.displayName = "TabsLayout.Copy";
Controls.displayName = "TabsLayout.Controls";
Media.displayName = "TabsLayout.Media";
Content.displayName = "TabsLayout.Content";
Control.displayName = "TabsLayout.Control";


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 2432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ TilesGrid; },
/* harmony export */   "W": function() { return /* binding */ TilesGridWrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13102);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);



var TilesGridWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eazx9zv1"
} : 0)("position:relative;width:100%;max-width:900px;height:320px;margin:0 auto;padding:80px 0 80px;overflow:hidden;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{max-width:1200px;height:385px;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:1480px;}&::before,&::after{content:'';display:block;width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;pointer-events:none;}&::before{", function (_ref3) {
  var gradientColor = _ref3.gradientColor;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("background:linear-gradient(90deg, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 35%),linear-gradient(0, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 50%);" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, ";}&::after{", function (_ref4) {
  var gradientColor = _ref4.gradientColor;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("background:linear-gradient(-90deg, ", gradientColor, " 0%, ", (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .transparentize */ .DZ)(1, gradientColor), " 35%);" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, ";}" + ( true ? "" : 0));
var TilesGrid = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eazx9zv0"
} : 0)("position:absolute;top:50%;left:50%;z-index:0;transform:translate(-50%, -50%);width:900px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("sm");
}, "{width:1200px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{width:1480px;}" + ( true ? "" : 0));

/***/ }),

/***/ 20442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LogoTiles; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/useInView/index.ts + 1 modules
var useInView = __webpack_require__(85807);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/LogoTiles.views.tsx
var LogoTiles_views = __webpack_require__(2432);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoTiles/LogoTiles.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var LogoGrid = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5922), __webpack_require__.e(5838)]).then(__webpack_require__.bind(__webpack_require__, 75838));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(75838)];
    }
  }
});

var BaseLogoTiles = function BaseLogoTiles(_ref) {
  var tokens = _ref.tokens;
  var wrapperRef = (0,react.useRef)(null);
  var isInView = (0,useInView/* default */.Z)(wrapperRef, {
    options: {
      rootMargin: "200px"
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles_views/* TilesGridWrapper */.W, _objectSpread(_objectSpread({}, tokens), {}, {
    ref: wrapperRef,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles_views/* TilesGrid */.$, {
      children: isInView && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoGrid, {})
    })
  }));
};

var LogoTiles = (0,useDesignTokens/* withDesignTokens */.Y)(BaseLogoTiles, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      gradientColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      gradientColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      gradientColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/LogoTiles/index.ts


/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 63009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useMaskOnScroll_useMaskOnScroll; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-value.mjs
var use_motion_value = __webpack_require__(21687);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/scroll/use-element-scroll.mjs
var use_element_scroll = __webpack_require__(66057);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs + 1 modules
var use_transform = __webpack_require__(29682);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-motion-template.mjs
var use_motion_template = __webpack_require__(85770);
// EXTERNAL MODULE: ../../libs/utils/useResizeObserver/index.ts + 1 modules
var useResizeObserver = __webpack_require__(73889);
;// CONCATENATED MODULE: ../../libs/utils/useMaskOnScroll/useMaskOnScroll.ts



var _templateObject;




/**
 * A hook to create a mask on scroll
 * @param props.wrapper - A ref to the element to observe
 * @param props.axis - The axis to apply the mask
 * @param props.offset - The offset to apply to the mask
 * @returns A string to use as a mask
 */

var useMaskOnScroll = function useMaskOnScroll(_ref) {
  var wrapper = _ref.wrapper,
      _ref$axis = _ref.axis,
      axis = _ref$axis === void 0 ? "horizontal" : _ref$axis,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? "8%" : _ref$offset;
  var clientValue = (0,use_motion_value/* useMotionValue */.c)(0);
  var scrollValue = (0,use_motion_value/* useMotionValue */.c)(0);
  var sizeValue = (0,use_motion_value/* useMotionValue */.c)(0);

  var _useElementScroll = (0,use_element_scroll/* useElementScroll */.B)(wrapper),
      scrollYProgress = _useElementScroll.scrollYProgress,
      scrollXProgress = _useElementScroll.scrollXProgress;

  var isVertical = axis === "vertical";
  var scrollProgress = isVertical ? scrollYProgress : scrollXProgress;
  var values = /^([-.\d]+(?:\.\d+)?)(.*)$/.exec(offset);
  var degs = isVertical ? (0,use_motion_value/* useMotionValue */.c)(180) : (0,use_motion_value/* useMotionValue */.c)(90);
  var unit = (0,use_motion_value/* useMotionValue */.c)(values && values[2]);
  var offsetValue = values ? Number(values[1]) : 0;

  if (isVertical) {
    var _wrapper$current;

    sizeValue.set(unit.get() === "%" ? 100 : Number((_wrapper$current = wrapper.current) === null || _wrapper$current === void 0 ? void 0 : _wrapper$current.getBoundingClientRect().height));
  } else {
    var _wrapper$current2;

    sizeValue.set(unit.get() === "%" ? 100 : Number((_wrapper$current2 = wrapper.current) === null || _wrapper$current2 === void 0 ? void 0 : _wrapper$current2.getBoundingClientRect().width));
  }

  (0,react.useEffect)(function () {
    if (unit.get() === "%") return;

    var handleResize = function handleResize() {
      if (isVertical) {
        var _wrapper$current3;

        sizeValue.set(Number((_wrapper$current3 = wrapper.current) === null || _wrapper$current3 === void 0 ? void 0 : _wrapper$current3.getBoundingClientRect().height));
      } else {
        var _wrapper$current4;

        sizeValue.set(Number((_wrapper$current4 = wrapper.current) === null || _wrapper$current4 === void 0 ? void 0 : _wrapper$current4.getBoundingClientRect().width));
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [isVertical, unit]);
  var maskStartSize = (0,use_transform/* useTransform */.H)([clientValue, scrollValue, scrollProgress], function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 3),
        clientValue = _ref3[0],
        scrollValue = _ref3[1],
        scrollProgressValue = _ref3[2];

    return clientValue === scrollValue ? 0 : Math.min(offsetValue, scrollProgressValue * sizeValue.get());
  });
  var maskEndSize = (0,use_transform/* useTransform */.H)([clientValue, scrollValue, scrollProgress], function (_ref4) {
    var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 3),
        clientValue = _ref5[0],
        scrollValue = _ref5[1],
        scrollProgressValue = _ref5[2];

    return clientValue === scrollValue ? sizeValue.get() : Math.max(sizeValue.get() - offsetValue, scrollProgressValue * sizeValue.get());
  });
  var maskImage = (0,use_motion_template/* useMotionTemplate */.Y)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["linear-gradient(", "deg, rgba(0,0,0,0) 0", ", rgba(0,0,0,1) ", "", ", rgba(0,0,0,1) ", "", ", rgba(0,0,0,0) ", "", ")"])), degs, unit, maskStartSize, unit, maskEndSize, unit, sizeValue, unit);
  var setValue = (0,react.useCallback)(function () {
    var _ref6, _wrapper$current5, _wrapper$current6, _ref7, _wrapper$current7, _wrapper$current8;

    clientValue.set((_ref6 = isVertical ? (_wrapper$current5 = wrapper.current) === null || _wrapper$current5 === void 0 ? void 0 : _wrapper$current5.clientHeight : (_wrapper$current6 = wrapper.current) === null || _wrapper$current6 === void 0 ? void 0 : _wrapper$current6.clientWidth) !== null && _ref6 !== void 0 ? _ref6 : 0);
    scrollValue.set((_ref7 = isVertical ? (_wrapper$current7 = wrapper.current) === null || _wrapper$current7 === void 0 ? void 0 : _wrapper$current7.scrollHeight : (_wrapper$current8 = wrapper.current) === null || _wrapper$current8 === void 0 ? void 0 : _wrapper$current8.scrollWidth) !== null && _ref7 !== void 0 ? _ref7 : 0);
  }, [clientValue, wrapper, scrollValue]);
  (0,useResizeObserver/* default */.Z)(wrapper, setValue);
  (0,react.useEffect)(function () {
    return setValue();
  }, [setValue]);
  return maskImage;
};

/* harmony default export */ var useMaskOnScroll_useMaskOnScroll = (useMaskOnScroll);
;// CONCATENATED MODULE: ../../libs/utils/useMaskOnScroll/index.ts


/***/ }),

/***/ 32523:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A hook to scroll to an element
 *
 * @param container - A ref to the container to scroll
 * @returns A function to scroll to an element
 */
var useScrollTo = function useScrollTo(container) {
  return function (element) {
    var el = element.current;
    var parent = container.current;

    if (parent && el) {
      parent.scrollTo({
        left: el.offsetLeft - (parent.offsetWidth - el.offsetWidth) / 2,
        behavior: "smooth"
      });
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollTo);

/***/ }),

/***/ 53938:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(81745);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 70142:
/***/ (function(module) {

module.exports = "/_next/static/images/BusinessPlan-sm-8187c914524786b08117a80947125cd9.png";

/***/ }),

/***/ 501:
/***/ (function(module) {

module.exports = "/_next/static/images/BusinessPlan-sm@2x-3823092429c9bc2546a9fa023e28640e.png";

/***/ }),

/***/ 55084:
/***/ (function(module) {

module.exports = "/_next/static/images/BusinessPlan-xs-3ce8969dadaf5e54d6a2137acf1fddfa.png";

/***/ }),

/***/ 62454:
/***/ (function(module) {

module.exports = "/_next/static/images/FreePlan-sm-5cecb2f6e9e55b3d57be8c7ce3060e1f.png";

/***/ }),

/***/ 12034:
/***/ (function(module) {

module.exports = "/_next/static/images/FreePlan-sm@2x-1fcad151d868d23187d00a1a3a800e5e.png";

/***/ }),

/***/ 36819:
/***/ (function(module) {

module.exports = "/_next/static/images/FreePlan-xs-54a1172527a79156809054fff074b95c.png";

/***/ }),

/***/ 17400:
/***/ (function(module) {

module.exports = "/_next/static/images/TeamPlan-sm-9a4910eb4141d352af54fb0e6056d052.png";

/***/ }),

/***/ 32551:
/***/ (function(module) {

module.exports = "/_next/static/images/TeamPlan-sm@2x-cffca70c5dcd29578895d4f8633de501.png";

/***/ }),

/***/ 38620:
/***/ (function(module) {

module.exports = "/_next/static/images/TeamPlan-xs-6b66033ade1a271b646f25e993e3613c.png";

/***/ }),

/***/ 17839:
/***/ (function(module) {

module.exports = "/_next/static/images/BusinessPlan-sm-ef91e92a862aa505572702947dd7c9a2.webp";

/***/ }),

/***/ 44270:
/***/ (function(module) {

module.exports = "/_next/static/images/BusinessPlan-sm@2x-a3d48a78112a453db54be3e7064a3491.webp";

/***/ }),

/***/ 53448:
/***/ (function(module) {

module.exports = "/_next/static/images/BusinessPlan-xs-ee2a81590ed85e0b8570c29a77a47bb1.webp";

/***/ }),

/***/ 84337:
/***/ (function(module) {

module.exports = "/_next/static/images/FreePlan-sm-8b90e21e75763ee1c861a0e4f098a630.webp";

/***/ }),

/***/ 28805:
/***/ (function(module) {

module.exports = "/_next/static/images/FreePlan-sm@2x-0d8e73216ca2daf0d337bae037537396.webp";

/***/ }),

/***/ 4659:
/***/ (function(module) {

module.exports = "/_next/static/images/FreePlan-xs-a0a09f8c892a4b121da9ec7cd94a40ca.webp";

/***/ }),

/***/ 27236:
/***/ (function(module) {

module.exports = "/_next/static/images/TeamPlan-sm-5e59142e9b025b082cf1e568ee8d0e82.webp";

/***/ }),

/***/ 92147:
/***/ (function(module) {

module.exports = "/_next/static/images/TeamPlan-sm@2x-4da26738e468b97b9387d4d1bbc0ee35.webp";

/***/ }),

/***/ 75764:
/***/ (function(module) {

module.exports = "/_next/static/images/TeamPlan-xs-dd4e87f8b12cce7d8e4ffed1b186ad8d.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ }),

/***/ 28957:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ LayoutGroup; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(3422);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/context/DeprecatedLayoutGroupContext.mjs


/**
 * @deprecated
 */
var DeprecatedLayoutGroupContext = (0,react.createContext)(null);



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-force-update.mjs
var use_force_update = __webpack_require__(85886);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/projection/node/group.mjs
var notify = function (node) {
    return !node.isLayoutDirty && node.willUpdate(false);
};
function nodeGroup() {
    var nodes = new Set();
    var subscriptions = new WeakMap();
    var dirtyAll = function () { return nodes.forEach(notify); };
    return {
        add: function (node) {
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: function (node) {
            var _a;
            nodes.delete(node);
            (_a = subscriptions.get(node)) === null || _a === void 0 ? void 0 : _a();
            subscriptions.delete(node);
            dirtyAll();
        },
        dirty: dirtyAll,
    };
}



;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/components/LayoutGroup/index.mjs








var shouldInheritGroup = function (inherit) { return inherit === true; };
var shouldInheritId = function (inherit) {
    return shouldInheritGroup(inherit === true) || inherit === "id";
};
var LayoutGroup = function (_a) {
    var _b, _c;
    var children = _a.children, id = _a.id, inheritId = _a.inheritId, _d = _a.inherit, inherit = _d === void 0 ? true : _d;
    // Maintain backwards-compatibility with inheritId until 7.0
    if (inheritId !== undefined)
        inherit = inheritId;
    var layoutGroupContext = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p);
    var deprecatedLayoutGroupContext = (0,react.useContext)(DeprecatedLayoutGroupContext);
    var _e = (0,tslib_es6/* __read */.CR)((0,use_force_update/* useForceUpdate */.N)(), 2), forceRender = _e[0], key = _e[1];
    var context = (0,react.useRef)(null);
    var upstreamId = (_b = layoutGroupContext.id) !== null && _b !== void 0 ? _b : deprecatedLayoutGroupContext;
    if (context.current === null) {
        if (shouldInheritId(inherit) && upstreamId) {
            id = id ? upstreamId + "-" + id : upstreamId;
        }
        context.current = {
            id: id,
            group: shouldInheritGroup(inherit)
                ? (_c = layoutGroupContext === null || layoutGroupContext === void 0 ? void 0 : layoutGroupContext.group) !== null && _c !== void 0 ? _c : nodeGroup()
                : nodeGroup(),
        };
    }
    var memoizedContext = (0,react.useMemo)(function () { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context.current), { forceRender: forceRender })); }, [key]);
    return (react.createElement(LayoutGroupContext/* LayoutGroupContext.Provider */.p.Provider, { value: memoizedContext }, children));
};




/***/ }),

/***/ 66057:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useElementScroll; }
/* harmony export */ });
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3105);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7622);
/* harmony import */ var _events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27723);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23617);
/* harmony import */ var hey_listen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9340);






var getElementScrollOffsets = function (element) { return function () {
    return {
        xOffset: element.scrollLeft,
        yOffset: element.scrollTop,
        xMaxOffset: element.scrollWidth - element.offsetWidth,
        yMaxOffset: element.scrollHeight - element.offsetHeight,
    };
}; };
/**
 * Returns MotionValues that update when the provided element scrolls:
 *
 * - `scrollX` — Horizontal scroll distance in pixels.
 * - `scrollY` — Vertical scroll distance in pixels.
 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
 *
 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const ref = useRef()
 *   const { scrollYProgress } = useElementScroll(ref)
 *
 *   return (
 *     <div ref={ref}>
 *       <motion.div style={{ scaleX: scrollYProgress }} />
 *     </div>
 *   )
 * }
 * ```
 *
 * @public
 */
function useElementScroll(ref) {
    var values = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useConstant */ .h)(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollMotionValues */ .w);
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function () {
        var element = ref.current;
        (0,hey_listen__WEBPACK_IMPORTED_MODULE_3__/* .invariant */ .k)(!!element, "ref provided to useScroll must be passed into a HTML element.");
        if (!element)
            return;
        var updateScrollValues = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollUpdater */ .S)(values, getElementScrollOffsets(element));
        var scrollListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "scroll", updateScrollValues);
        var resizeListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "resize", updateScrollValues);
        return function () {
            scrollListener && scrollListener();
            resizeListener && resizeListener();
        };
    }, []);
    return values;
}




/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ createScrollUpdater; },
/* harmony export */   "w": function() { return /* binding */ createScrollMotionValues; }
/* harmony export */ });
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40226);


function createScrollMotionValues() {
    return {
        scrollX: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollY: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollXProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollYProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
    };
}
function setProgress(offset, maxOffset, value) {
    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
}
function createScrollUpdater(values, getOffsets) {
    var update = function () {
        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
        // Set absolute positions
        values.scrollX.set(xOffset);
        values.scrollY.set(yOffset);
        // Set 0-1 progress
        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
    };
    update();
    return update;
}




/***/ }),

/***/ 77014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCombineMotionValues; }
/* harmony export */ });
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21687);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29709);
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76432);




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useMotionValue */ .c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMultiOnChange */ .f)(values, function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(updateValue, false, true); });
    return value;
}




/***/ }),

/***/ 85770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMotionTemplate; }
/* harmony export */ });
/* harmony import */ var _use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77014);


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return (0,_use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useCombineMotionValues */ .N)(values, buildValue);
}




/***/ }),

/***/ 21687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41412);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40226);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60976);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(function () { return (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._).isStatic;
    if (isStatic) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__read */ .CR)((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}




/***/ }),

/***/ 29709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15815);



function useOnChange(value, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}




/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(1560);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs
var use_combine_values = __webpack_require__(77014);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return (0,use_combine_values/* useCombineMotionValues */.N)(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,7209,8834,4330,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,3996,7947,7960,6012,7079,1385,5062,6278,2935,9774,2888,179], function() { return __webpack_exec__(53938); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);